import type { C2Event, GeoLocation } from '../types';

export function isValidGeoLocation(loc?: GeoLocation | null): loc is GeoLocation {
  if (!loc) return false;
  const { latitude: lat, longitude: lng } = loc;
  if (lat == null || lng == null) return false;
  if (lat === 0 && lng === 0) return false;
  return true;
}

export function getEventMapCenter(event?: C2Event | null): [number, number] | undefined {
  if (!isValidGeoLocation(event?.location)) return undefined;
  return [event.location.latitude, event.location.longitude];
}

export function formatEventLocationLabel(event?: C2Event | null): string {
  if (!event) return '';
  const addr = event.location?.address?.trim();
  if (addr && addr !== 'TBD' && addr !== 'Selected on map') return addr;
  const center = getEventMapCenter(event);
  if (center) return `${center[0].toFixed(5)}, ${center[1].toFixed(5)}`;
  return 'Location not set';
}
